module.exports = __webpack_public_path__ + "img/selected5-min.71079246.png";